import React from 'react';
import { useWatch } from 'react-hook-form';
import {
  ClassifierFormDataType,
  FormSegmentLabel,
  FormSegments,
} from '@atlas-frontend/sdk';
import { CategoryFormTable } from '../table/CategoryFormTable';
import { useClassifierFormLabelTranslation } from './useClassifierFormLabelTranslation';
import { CategoryHierarchyFormTable } from '../table/CategoryHierarchyFormTable';

export const ClassifierFormSegments = () => {
  const { t } = useClassifierFormLabelTranslation();

  const hasCategories = useWatch<ClassifierFormDataType>({
    name: 'hasCategories',
  }) as boolean;

  if (!hasCategories) {
    return null;
  }

  return (
    <FormSegments
      segments={[
        {
          value: 'categories',
          label: (
            <FormSegmentLabel
              segmentValue="categories"
              formFieldName="categories"
            >
              {t('categories.label')}
            </FormSegmentLabel>
          ),
          children: <CategoryFormTable key="categories" name="categories" />,
        },
        {
          value: 'categoryGroups',
          label: (
            <FormSegmentLabel
              segmentValue="categoryGroups"
              formFieldName="categoryGroups"
            >
              {t('categoryGroups.label')}
            </FormSegmentLabel>
          ),
          children: (
            <CategoryFormTable key="categoryGroups" name="categoryGroups" />
          ),
        },
        {
          value: 'combinedGroups',
          label: (
            <FormSegmentLabel
              segmentValue="combinedGroups"
              formFieldName="combinedGroups"
            >
              {t('combinedGroups.label')}
            </FormSegmentLabel>
          ),
          children: (
            <CategoryFormTable key="combinedGroups" name="combinedGroups" />
          ),
        },
        {
          value: 'hierarchy',
          label: (
            <FormSegmentLabel
              segmentValue="hierarchy"
              formFieldName="hierarchy"
            >
              {t('hierarchy.label')}
            </FormSegmentLabel>
          ),
          children: <CategoryHierarchyFormTable key="hierarchy" />,
        },
      ]}
    />
  );
};
